"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ShopperData = exports["default"] = void 0;

var _syncAccess = _interopRequireDefault(require("./sync-access"));

var _util = require("@ux/util");

var _global = require("./global");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ShopperData =
/*#__PURE__*/
function (_SyncAccess) {
  _inherits(ShopperData, _SyncAccess);

  function ShopperData() {
    _classCallCheck(this, ShopperData);

    return _possibleConstructorReturn(this, _getPrototypeOf(ShopperData).apply(this, arguments));
  }

  _createClass(ShopperData, [{
    key: "fetch",
    value: function fetch(done) {
      //
      // This is suppose to be internal data, but we really need shopper information.
      //
      var shopperData = (0, _global.get)('window', 'ux.eldorado.shopperData') || function (d) {
        return d();
      }; //
      // Ugly hack but unfortunately the only way to access shopper data atm. Since the data was likely already
      // fetched by the header it should call the callback immediate with data. Obviously this should be possible
      // sync, or this data should be available somewhere. Fire and forget, hope for the best...
      //


      shopperData(done);
    }
    /**
     * Massages the info_idp cookie value into something that looks like the results of ux.eldorado.shopperData
     * @param {string} cookieValue The value of the info_idp cookie (or equivalent)
     * @returns {InitialShopperData} The parsed cookie value
     */

  }, {
    key: "transform",
    value: function transform(_ref) {
      var cookieValue = _ref.info;

      try {
        var idpData = JSON.parse(cookieValue);

        var result = _objectSpread({}, idpData, {}, idpData && idpData[idpData.auth]);

        result.info = cookieValue; // fix up the shopperid property to have the right name.
        // Casing here is intentional to match what comes back from shopperData

        if (result.info_shopperId) {
          result.shopperid = result.info_shopperId;
        }

        delete result.info_shopperId;
        return result;
      } catch (e) {
        return {};
      }
    }
  }, {
    key: "defaults",
    get: function get() {
      return {
        info: _util.cookie.get && _util.cookie.get('info_idp') || '{}'
      };
    }
  }]);

  return ShopperData;
}(_syncAccess["default"]); // Expose just the method


exports.ShopperData = ShopperData;
var _default = new ShopperData().data; // Expose the raw class for testing

exports["default"] = _default;